import { CourseCategoryType } from "../../utils/types";

export const CourseCategory: CourseCategoryType = [
  // {
  //   categoryID: "hardware",
  //   categoryName: "Hardware",
  //   imgUrl:
  //     "https://i.imgur.com/eUWU240.png",
  //   isActive: false,
  // },
  {
    categoryID: "PCB",
    categoryName: "PCB Course",
    imgUrl:
      "https://i.imgur.com/eUWU240.png",
    isActive: true,
  },
  {
    categoryID: "PCB Competition",
    categoryName: "PCB Competition",
    imgUrl:
      "https://i.imgur.com/V877Rpn.png",
    isActive: true,
  },
  {
    categoryID: "workshop",
    categoryName: "Workshop",
    imgUrl:
      "https://i.imgur.com/gyWBzU5.png",
    isActive: true,
  },
  {
    categoryID: "software_Driver",
    categoryName: "Software & Driver",
    imgUrl:
      "https://i.imgur.com/hhvQeXC.png",
    isActive: true,
  },
  {
    categoryID: "fpga",
    categoryName: "FPGA",
    imgUrl:
      "https://i.imgur.com/tmj4q4Q.png",
    isActive: true,
  },
  {
    categoryID: "art",
    categoryName: "Art",
    imgUrl:
      "https://mdbcdn.b-cdn.net/img/Photos/Horizontal/Nature/4-col/img%20(76).webp",
    isActive: false,
  },
];
